module.exports = __webpack_public_path__ + "static/img/kb-logo.9c76cc6c.svg";